import axios from "axios";
import { Location_Service_URL, Partner_Service_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const FirmDetailMasterActions = {
  FIRM_DETAIL_MASTER_SUCCESS: "FIRM_DETAIL_MASTER_SUCCESS",
  FIRM_DETAIL_MASTER_ERROR: "FIRM_DETAIL_MASTER_ERROR",
};

export function firmDetailMaster(props) {
  const accessToken = props;

  return (dispatch) =>
    axios({
      method: "post",
      url: `${Partner_Service_URL}/get/partnerFirmDetailsMasters`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(firmDetailMasterSuccess(response.data));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(firmDetailMasterError(error));

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        }
      });
}

export function firmDetailMasterError(error) {
  return {
    type: FirmDetailMasterActions.FIRM_DETAIL_MASTER_ERROR,
    payload: error,
  };
}

export function firmDetailMasterSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: FirmDetailMasterActions.FIRM_DETAIL_MASTER_SUCCESS,
      payload: props,
    });
  };
}

export const firmConstitutionActions = {
  FIRM_CONSTITUTION_SUCCESS: "FIRM_CONSTITUTION_SUCCESS",
  FIRM_CONSTITUTION_ERROR: "FIRM_CONSTITUTION_ERROR",
};

export function getFirmConstitutionDetail(accessToken, partnerFrimID) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Partner_Service_URL}/getPartnerFirmConstitution?partnerFirmId=${partnerFrimID}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(firmConstitutionSuccess(response.data.dto));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          // dispatch(firmDetailMasterError(error))

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
}

export function firmConstitutionError(error) {
  return {
    type: firmConstitutionActions.FIRM_CONSTITUTION_ERROR,
    payload: error,
  };
}

export function firmConstitutionSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: firmConstitutionActions.FIRM_CONSTITUTION_SUCCESS,
      payload: props,
    });
  };
}

export const getFirmDetailsAction = {
  GET_FIRM_DETAIL_SUCCESS: "GET_FIRM_DETAIL_SUCCESS",
  GET_FIRM_DETAIL_ERROR: " GET_FIRM_DETAIL_ERROR",
};

export function getFirmDetail(accessToken, partnerFrimID) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Partner_Service_URL}/getPartnerFirmDetails?partnerFirmId=${partnerFrimID}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(firmDetailSuccess(response.data.dto));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getFirmDetailError(error));

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
}

export function getFirmDetailError(error) {
  return {
    type: getFirmDetailsAction.GET_FIRM_DETAIL_ERROR,
    payload: error,
  };
}

export function firmDetailSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getFirmDetailsAction.GET_FIRM_DETAIL_SUCCESS,
      payload: props,
    });
  };
}

export function getBirthCountryDetails(props) {

  const { access_token, country } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Location_Service_URL}/search/Country?countryName=${country}`,

    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          //  dispatch(getBirthCountrySuccess(response));
          return response;
        } else {

          const error = new Error(response.statusText);
          //  dispatch(getBirthCountryError(error));
          throw error;
        }
      })
      .catch((err) => {
        console.log("line47");

      });
}

// Pan verfication

export const getFirmPanDetailsAction = {
  GET_FIRM_PAN_DETAIL_SUCCESS: "GET_FIRM_PAN_DETAIL_SUCCESS",
  GET_FIRM_PAN_DETAIL_ERROR: " GET_FIRM_PAN_DETAIL_ERROR",
};

export function getFirmPanDetail(accessToken, partnerFrimID) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Partner_Service_URL}/getPartnerPANDetails?partnerFirmId=${partnerFrimID}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getFirmDetailPanSuccess(response.data.dto));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getFirmPanDetailError(error));

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
}

export function getFirmPanDetailError(error) {
  return {
    type: getFirmPanDetailsAction.GET_FIRM_PAN_DETAIL_SUCCESS,
    payload: error,
  };
}

export function getFirmDetailPanSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getFirmPanDetailsAction.GET_FIRM_PAN_DETAIL_SUCCESS,
      payload: props,
    });
  };
}

export const HeadOfficeActions = {
  HEAD_OFFICE_SUCCESS: "HEAD_OFFICE_SUCCESS",
  HEAD_OFFICE_ERROR: "HEAD_OFFICE_ERROR",
};
export function getHeadOfficeDetail(accesToken, partnerId) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Partner_Service_URL}/getPartnerCommunicationDetails?partnerFirmId=${partnerId}`,
      headers: {
        authorization: "Bearer " + accesToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(HeadOfficeSuccess(response.data.dto));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          // dispatch(firmDetailMasterError(error))

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
}

export function HeadOfficeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: HeadOfficeActions.HEAD_OFFICE_SUCCESS,
      payload: props,
    });
  };
}

// AccountNumberDetail verfication

export const getFirmAccountNumberDetailsAction = {
  GET_FIRM_ACCOUNTNUMBER_DETAIL_SUCCESS:
    "GET_FIRM_ACCOUNTNUMBER_DETAIL_SUCCESS",
  GET_FIRM_ACCOUNTNUMBER_DETAIL_ERROR: " GET_FIRM_ACCOUNTNUMBER_DETAIL_ERROR",
};

export function getFirmAccountNumberDetail(accessToken, partnerFrimID) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Partner_Service_URL}/getPartnerBankDetails?partnerFirmId=${partnerFrimID}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getFirmDetailAccountNumSuccess(response.data.dto));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getFirmDetailAccountNumError(error));

          return response;
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
}

export function getFirmDetailAccountNumError(error) {
  return {
    type: getFirmAccountNumberDetailsAction.GET_FIRM_ACCOUNTNUMBER_DETAIL_ERROR,
    payload: error,
  };
}

export function getFirmDetailAccountNumSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getFirmAccountNumberDetailsAction.GET_FIRM_ACCOUNTNUMBER_DETAIL_SUCCESS,
      payload: props,
    });
  };
}

// Firm Save all Start
export const firmSaveAllActions = {
  FIRM_SAVEALL_SUCCESS: "FIRM_SAVEALL_SUCCESS",
  FIRM_SAVEALL_ERROR: "FIRM_SAVEALL_ERROR",
};

export function saveFirmSaveAllDetails(props) {
  const { accessToken, partnerFirmId, values } = props;

  return (dispatch) =>
    axios({
      method: "post",
      url: `${Partner_Service_URL}/saveAllFirmDetails?partnerFirmId=${partnerFirmId}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(firmSaveAllSuccess(response.data.dto));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        } else {
          const error = new Error(response.statusText);
          // dispatch(firmDetailMasterError(error))

          // return response;
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        } else if (!err.response) {
        }
      });
}

export function firmSaveAllError(error) {
  return {
    type: firmSaveAllActions.FIRM_SAVEALL_ERROR,
    payload: error,
  };
}

export function firmSaveAllSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: firmSaveAllActions.FIRM_SAVEALL_SUCCESS,
      payload: props,
    });
  };
}
